import { render, staticRenderFns } from "./ServiceCatalogPricingForm.vue?vue&type=template&id=e8de6754&"
import script from "./ServiceCatalogPricingForm.vue?vue&type=script&lang=js&"
export * from "./ServiceCatalogPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports